import { Modal } from "antd";
import { Layout } from "antd";
import PostAdd from "./Screens/PostAdd";
import "./News.scss";
import { CloseOutlined } from "@ant-design/icons";

const NewsModal = ({
  isModalVisible,
  setModalVisible,
  organizationData,
  currentData,
  onNewsPosted,
  isEditMode = false,
}: any) => {
  const handleOk = () => {
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
 };

  return (
    <Layout>
      <Modal
        className="organization_model"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered={true}
        footer={null}
        width={600}
      >
        <div className="model-header news-model-header">
          <h4>{isEditMode ? "Edit a News" : "Create a News"} </h4>
          <button className="close-btn" onClick={handleCancel}>
            <CloseOutlined />
          </button>
        </div>
        <PostAdd key={currentData?._id || "create"} organizationData={organizationData} editData={currentData} handleCancel={handleCancel} onNewsPosted={onNewsPosted} isEditMode={isEditMode} />
      </Modal>
    </Layout>
  );
};
export default NewsModal;
